<!-- placead -->
<div class="mdc-layout-grid__inner" *ngIf="topic === 'place-ad'">
	<div class="mdc-layout-grid__cell--span-12 header n127">
		<mat-icon class="mat-icon-rtl-mirror h-auto">add_circle_outline</mat-icon>
		<h1>{{ locale.translations['help']['placead']['n127'] }}</h1>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<p class="n130">{{ locale.translations['help']['placead']['n130'] }}</p>

		<ol>
			<li class="n131">
				{{ locale.translations['help']['placead']['n131'] }}
			</li>

			<li class="n132">
				{{ locale.translations['help']['placead']['n132'] }}
			</li>

			<li class="n133">
				{{ locale.translations['help']['placead']['n133'] }}
			</li>

			<li class="n134">
				{{ locale.translations['help']['placead']['n134'] }}
			</li>

			<li class="n135">
				{{ locale.translations['help']['placead']['n135'] }}
			</li>

			<li class="n136">
				{{ locale.translations['help']['placead']['n136'] }}
			</li>

			<li class="n137">
				{{ locale.translations['help']['placead']['n137'] }}
			</li>

			<li class="n138">
				{{ locale.translations['help']['placead']['n138'] }}
			</li>

			<li class="n139">
				{{ locale.translations['help']['placead']['n139'] }}
			</li>

			<li class="n140">
				{{ locale.translations['help']['placead']['n140'] }}
			</li>
		</ol>
	</div>
</div>
<!-- /placead -->

<!-- logup -->
<div class="mdc-layout-grid__inner" *ngIf="topic === 'logup'">
	<div class="mdc-layout-grid__cell--span-12 header n128">
		<mat-icon class="mat-icon-rtl-mirror h-auto">exit_to_app</mat-icon>
		<h1>{{ locale.translations['help']['logup']['n128'] }}</h1>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<p class="n141">{{ locale.translations['help']['logup']['n141'] }}</p>

		<ol>
			<li class="n142">
				{{ locale.translations['help']['logup']['n142'] }}
			</li>

			<li class="n143">
				{{ locale.translations['help']['logup']['n143'] }}
			</li>

			<li class="n144">
				{{ locale.translations['help']['logup']['n144'] }}
			</li>

			<li class="n145">
				{{ locale.translations['help']['logup']['n145'] }}
			</li>

			<li class="n146">
				{{ locale.translations['help']['logup']['n146'] }}
			</li>

			<li class="n147">
				{{ locale.translations['help']['logup']['n147'] }}
			</li>
		</ol>
	</div>
</div>
<!-- /logup -->

<!-- language -->
<div class="mdc-layout-grid__inner" *ngIf="topic === 'language'">
	<div class="mdc-layout-grid__cell--span-12 header n129">
		<mat-icon class="h-auto">language</mat-icon>
		<h1>{{ locale.translations['help']['language']['n129'] }}</h1>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<p class="n148">{{ locale.translations['help']['language']['n148'] }}</p>

		<ol>
			<li class="n149">
				{{ locale.translations['help']['language']['n149'] }}
			</li>

			<li class="n150">
				{{ locale.translations['help']['language']['n150'] }}
			</li>
		</ol>
	</div>
</div>
<!-- /language -->
